import MattressLayer from './mattress-layer-v2';

export * from './mattress-layer-v2';
export default MattressLayer;
